import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { AssetExportConfiguration } from './assetExportConfiguration';

export class AssetExportConfigurationInput
  extends AssetExportConfiguration
  implements EntityInput<AssetExportConfiguration>
{
  forCreate(): CreateAssetExportConfigurationInput {
    return CreateAssetExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      CreateAssetExportConfigurationInput,
    );
  }

  forUpdate(): UpdateAssetExportConfigurationInput {
    return UpdateAssetExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      UpdateAssetExportConfigurationInput,
    );
  }

  forDelete(): DeleteAssetExportConfigurationInput {
    return DeleteAssetExportConfigurationInput.from(this, DeleteAssetExportConfigurationInput);
  }
}

export class CreateAssetExportConfigurationInput extends forCreate(AssetExportConfiguration) {}

export class UpdateAssetExportConfigurationInput extends forUpdate(AssetExportConfiguration) {}

export class DeleteAssetExportConfigurationInput extends forDelete(AssetExportConfiguration) {}
